import React from "react";
import AntdList, {ListProps} from "antd/lib/list";
import {ListItemTypeProps} from "antd/lib/list/Item";
import { withError } from '@fishx/tracker';

const Item = AntdList.Item;
interface FCListProps extends React.FC<ListProps<ListItemTypeProps>> {
  Item: typeof Item;
}
export const List: FCListProps = (props) => {
  return <AntdList {...props} />;
}
List.Item = Item;
List.displayName = 'List';
export default withError(List);



// WEBPACK FOOTER //
// ./src/components/list/index.tsx